import React from 'react';

export default () => (
  <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1">
    <title>chart-symbol-circle</title>
    <desc>Created with Sketch.</desc>
    <g id="chart-symbol-circle" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle id="Oval-Copy-4" fill="#3072BE" fillRule="nonzero" cx="6" cy="6" r="5.5" />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/chart-symbol-circle.es6.js